import { render, staticRenderFns } from "./ModificarTagMotivoCita.vue?vue&type=template&id=38abac28&scoped=true"
import script from "./ModificarTagMotivoCita.vue?vue&type=script&lang=js"
export * from "./ModificarTagMotivoCita.vue?vue&type=script&lang=js"
import style0 from "./ModificarTagMotivoCita.vue?vue&type=style&index=0&id=38abac28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abac28",
  null
  
)

export default component.exports